import { render } from "./PropertyPerview.vue?vue&type=template&id=4ae8e1c3"
import script from "./PropertyPerview.vue?vue&type=script&lang=js"
export * from "./PropertyPerview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__